var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11705 6L10.5822 2.5349C11.0904 2.02668 11.1423 1.24703 10.6977 0.802343C10.253 0.357655 9.47332 0.409632 8.9651 0.917847L5.5 4.38295L2.0349 0.917847C1.52668 0.409632 0.747032 0.357655 0.302343 0.802343C-0.142345 1.24703 -0.0903685 2.02668 0.417847 2.5349L3.88295 6L0.417847 9.4651C-0.0903685 9.97332 -0.142345 10.753 0.302343 11.1977C0.747032 11.6423 1.52668 11.5904 2.0349 11.0822L5.5 7.61705L8.9651 11.0822C9.47332 11.5904 10.253 11.6423 10.6977 11.1977C11.1423 10.753 11.0904 9.97332 10.5822 9.4651L7.11705 6Z",
    fill: "#DC1919"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.0d30fdc00d4c7047690942d8ddba50f0.svg";
export { ForwardRef as ReactComponent };